import { AnyAction } from 'redux';
import { Position } from '@synergy/models';

import { RECEIVE_USER_POSITIONS } from '../actions/positions-actions';

export interface PositionsReducerState {
    positions: Position[];
}

const initialPositionsState: PositionsReducerState = {
    positions: [],
};

export const positionsReducer = (
    state: PositionsReducerState = initialPositionsState,
    action: AnyAction
): PositionsReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case RECEIVE_USER_POSITIONS: {
            return {
                ...state,
                positions: rest['positions'],
            };
        }

        default: {
            return state;
        }
    }
};
